import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import META from './useTrackOpenedBoardsFollowingModal.meta';

export const useTrackOpenedBoardsFollowingModal = () => {
  const { track } = useAnalyticsUtilities();

  const trackOpenedBoardsFollowingModal = useCallback(() => {
    track(META.name);
  }, [track]);

  return {
    trackOpenedBoardsFollowingModal,
  };
};
